import RepositoriesListItem from './RepositoriesListItem';

export default RepositoriesListItem;
